import { render } from "./PromotionAddEdit.vue?vue&type=template&id=66cad620&scoped=true&ts=true"
import script from "./PromotionAddEdit.vue?vue&type=script&lang=ts"
export * from "./PromotionAddEdit.vue?vue&type=script&lang=ts"

import "./PromotionAddEdit.vue?vue&type=style&index=0&id=66cad620&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cad620"]])

export default __exports__